import React from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';

class Form extends React.Component {
  render() {
    return <ReactTypeformEmbed url="https://u0c9uucvqal.typeform.com/to/bDdZhRwP" style={{}} />;
  }
}

export default Form;
